import { useInitData } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { BirdviewAttentionRow } from '../BirdviewAttentionRow'
import { BirdviewCard } from '../BirdviewCard'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'
import { getBirdviewRowRequestActions } from '../DashboardBirdview.utils'

function BirdviewAttentionWidget({
  dragHandleProps,
  requestActions,
  section,
  title,
  onLoadAttentionGroup,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  const { availableSections } = useInitData()

  const rowRequestActions = getBirdviewRowRequestActions({
    requestActions,
    onReload: section.reload,
  })

  function handleOpenItem(item) {
    onNavigate(getRequestProfilePathname({ availableSections, id: item.id }))
  }

  function handleShowAll() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.attention))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewAttentionRow
          item={item}
          key={item.id}
          requestActions={rowRequestActions}
          onLoadGroup={onLoadAttentionGroup}
          onOpenItem={handleOpenItem}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewAttentionWidget
